import type { SectionProps } from '@/components/success-gambling/components/section/section.types';
import { forwardRef } from 'react';
import clsx from 'clsx';
import '@/components/success-gambling/components/section/section.css';

const Section = forwardRef<HTMLDivElement, SectionProps>((props, ref) => {
  const { step = '', noLine = false, title, children } = props;

  return (
    <section ref={ref} className='success-gambling-section'>
      <h6 className='success-gambling-section__title'>
        {step ? (
          <span data-testid='gambling-section-step' className='success-gambling-section__step'>
            {step}
          </span>
        ) : null}
        <span data-testid='gambling-section-title'>{title}</span>
      </h6>
      <div
        data-testid='gambling-section-content'
        className={clsx('success-gambling-section__content', {
          'success-gambling-section__content--no-step': !step,
          'success-gambling-section__content--no-line': noLine,
        })}
      >
        {children}
      </div>
    </section>
  );
});

export default Section;
